import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, umsUrl } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { FAB_SURGE_UPDATE_EXISTING_USER, FAB_SURGE_UPDATE_EXISTING_USER_ERROR, FAB_SURGE_UPDATE_EXISTING_USER_SUCCESS } from '../../../actions.js';

function* updateExistingFabUser({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { id, ...data } = payload?.data || {};

    const response = yield call(apiCall, {
      url: `${umsUrl}/admin/v2/client/${id}`,
      method: 'PUT',
      headers: {
        ...filteredHeaders,
      },
      data,
    });

    if (response.status === 200 || response.status === 201) {
      yield put({
        type: FAB_SURGE_UPDATE_EXISTING_USER_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: FAB_SURGE_UPDATE_EXISTING_USER_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: FAB_SURGE_UPDATE_EXISTING_USER_ERROR, payload: error });
  }
}

export function* watchUpdateExistingFabUser() {
  yield takeEvery(FAB_SURGE_UPDATE_EXISTING_USER, updateExistingFabUser);
}

function* updateFabUserSaga() {
  yield all([fork(watchUpdateExistingFabUser)]);
}

export default updateFabUserSaga;
